module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3r4r6n9r-281b36daf55a0bcde7640919ad7de29d.svg";